export default class MathUtils {
    static isAlmostEqual(v1: number, v2: number, tolerance: number): boolean {
        return Math.abs(v1 - v2) <= tolerance;
    }

    static isWholeNumber(value: number): boolean {
        return Math.floor(value) - value === 0.0;
    }

    /**
     * For the given range [min, max] determine where the 'ref' value is, in terms of percentage.
     */
    static calcPercentageAlong(min: number, max: number, ref: number): number {
        return (ref - min) / (max - min);
    }

    static interpolate(val1: number, val2: number, percentage: number): number {
        return (val2 - val1) * percentage + val1;
    }

    /**
     * Round the given value, to the number of decimal places required.
     * @param val
     * @param numPlaces
     * @return
     */
    static round(val: number, numPlaces: number): number {
        const factor = Math.pow(10, numPlaces);
        if (val < 0) {
            return Math.round(Math.abs(val) * factor) / -factor;
        } else {
            return Math.round(val * factor) / factor;
        }
    }

    /**
     * Floor the given number to a number of decimal places.
     * @param double
     * @param val
     * @param int
     * @param numPlaces
     */
    static floor(val: number, numPlaces: number): number {
        const factor = Math.pow(10, numPlaces);
        if (val < 0) {
            return Math.floor(Math.abs(val) * factor) / -factor;
        } else {
            return Math.floor(val * factor) / factor;
        }
    }

    /**
     * Assuming numbers are divided into intervals of size 'interval',
     * return the nearest interval greater than or equal to 'value'
     * @param value
     * @param interval
     * @return
     */
    static nearestUpperInterval(value: number, interval: number): number {
        const rem = value % interval;
        return rem === 0 ? value : value + (interval - rem);
    }

    /**
     * Assuming numbers are divided into intervals of size 'interval',
     * return the nearest interval less than or equal to 'value'
     * @param value
     * @param interval
     * @return
     */
    static nearestLowerInterval(value: number, interval: number): number {
        const rem = value % interval;
        return value - rem;
    }

    /**
     * Return a pseudo random number in the range [min, max[
     * @param min
     * @param max
     * @return
     */
    static randomInt(min: number, max: number) {
        const diff = max - min;
        return Math.floor(Math.random() * diff) + min;
    }

    /**
     * Return the value that is above threshold, and nearest to it.
     * Useful when comparing results from String.indexOf() etc that use -1 as a 'not found' indicator.
     * @param value1
     * @param value2
     * @param threshold
     * @return
     */
    static minAboveThreshold(value1: number, value2: number, threshold: number) {
        if (value1 === value2) return value1;
        if (value1 <= threshold) return value2;
        if (value2 <= threshold) return value1;
        return value1 <= value2 ? value1 : value2;
    }

    static degreesToRadians(degrees): number {
        const pi = Math.PI;
        return degrees * (pi / 180);
    }

    static floorMod(n: number, m: number): number {
        return ((n % m) + m) % m;
    }
}
